import React from 'react';
import { ImageHeader } from '../components/ImageHeader';
import { useGuest } from '../contexts/GuestContext';
import weekendScheduleImage from 'url:../assets/weekend-schedule.jpg';

const WeekendSchedule = () => {
  const { guestType } = useGuest();
  const imageUrl = weekendScheduleImage;
  const headerContent = (
    <h1>
      Weekend Schedule
    </h1>
  );

  return (
    <>
      <ImageHeader imageUrl={imageUrl} headerContent={headerContent} />
      <article className="block-content block-content-longtext">
        <h2>Friday 9th October 2026</h2>

        <p className="subheader">Pub Quiz!</p>
        <p>
          We will host a pub quiz at 7:30pm at the Stroud Hotel, Station Road, Stroud GL5 3AP.
        </p>
        <p>
          The quiz will be a chance for us to welcome you to Stroud, for you to meet some of our other guests, and to test your knowledge with a friendly competition.
        </p>
      </article>
      <article className="block-content block-content-longtext">
        <h2>Saturday 10th October 2026</h2>
        <p className='subheader'>Wedding Ceremony & Reception</p>
        <ul className="timeline-list">
          <li><strong>12:00</strong>Guests arrive - fizz on arrival in the courtyard</li>
          <li><strong>13:00</strong>Ceremony begins in the Barn</li>
          <li><strong>13:30</strong>Drinks reception, canapés &amp; games in the Courtyard</li>
          <li><strong>14:30</strong>The Bar opens</li>
          <li><strong>15:00</strong>A sit down Feast in the Barn</li>
          <li><strong>15:30</strong>Speeches - the Best Man, the Maid of Honour, The Groom, The Bride</li>
          <li><strong>17:30</strong>Dessert table opens + tea & coffee </li>
          <li><strong>18:30</strong>First dance & two live sets from What's New, a Welsh Jazz Quintet</li>
          <li><strong>20:30</strong>Evening food served in the Barn</li>
          <li><strong>21:00</strong>Dancing, drinks, fire, frivolity in the Barn and Courtyard</li>
          <li><strong>23:00-23:45</strong>Carriages home</li>
        </ul>
      </article >
      <article className="block-content block-content-longtext">
        {guestType === 'farmhouse' && (
          <>
            <h2>Farmhouse Week - Monday to Thursday</h2>
            <p>
              The bulk of the wedding activities are Friday to Sunday, but we'll be arranging some events in the house from Monday to Thursday to reconnect with everyone who's staying around.</p>
            <p>Think big screen Mario Kart, a casino & cocktails night, a Padel court and a swimming pool / sauna double feature.</p>
            <p>
              More details to follow closer to the date!
            </p>
          </>
        )}
      </article >
    </>
  );
};

export default WeekendSchedule;
